import { REQUIRED_MESSAGE } from '@/constants';
import * as Yup from 'yup';

export const createEntrySchema = Yup.object().shape({
  training_data: Yup.array().of(
    Yup.object().shape({
      trigger_phrase: Yup.string().required(REQUIRED_MESSAGE),
      content_value: Yup.string().required(REQUIRED_MESSAGE),
      is_url: Yup.boolean(),
    }),
  ),
});
